import React, {  useEffect, useRef } from 'react';

import styles from './impressao.scss';



const Impressao = ({setOpenEvent, children, paperSize = {largura: 210, altura:297}, margin={top: 0, right:0, bottom:0, left: 0}}) => {

    const printArea = useRef()
    

    const openEvent = () => {

        const popupWinindow = window.open('', '_blank', 'titlebar=no,width=1000,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no');
        popupWinindow.document.open();
        const innerContents = printArea.current.outerHTML;// document.getElementById('print-area').outerHTML;

        let _paperSizeStr =  `${paperSize.largura}mm `;

        if(paperSize.altura){
            _paperSizeStr += `${paperSize.altura}mm`;
        }

        _paperSizeStr += `;`;

        
        let _leftStr = margin.left ?  `padding-left: ${margin.left}mm !important` : 'padding-left: 0';
        let _topStr = margin.top?  `padding-top: ${margin.top}mm !important` : 'padding-top: 0';
        let _rightStr = margin.right? `padding-right: ${margin.right}mm !important`: 'padding-right: 0';
        let _bottomStr = margin.bottom? `padding-bottom: ${margin.bottom}mm !important`: 'padding-bottom: 0';

        popupWinindow.document.write(
            `<html >
                <head>
                    <meta name="viewport" content="width=100%, initial-scale=1">
                    <style>
                
                
                        
                            * {
                                background:transparent !important;
                                color:#000 !important;
                                text-shadow:none !important;
                                filter:none !important;
                                -ms-filter:none !important;
                                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif, sans-serif;
                            }

                            @page { 
                                size:  ${_paperSizeStr} 
                                margin-top: 0mm; 
                                margin-left: 0mm;
                                margin-right: 0mm;
                                margin-bottom: 0mm;
                                
                            }
                            
                            body, html { 
                                background: white; 
                                width: ${paperSize.largura}mm !important;                                
                                margin: 0;
                            }   
                            
                            
                            body {
                                line-height: 1.4em;
                                display: block;
                                ${_leftStr};
                                ${_topStr};
                                ${_rightStr};
                                ${_bottomStr};
                            }
                        

                        
                    </style>
                </head>
                <body onload="window.print()">
                    ${innerContents} 
                </html>`);

    popupWinindow.document.close();
    
    }
    

    useEffect(() =>{
        setOpenEvent && setOpenEvent({send: openEvent});

    }, []);
    
    return (
        <div className={styles['impressao-wrapper']} ref={printArea} >
            {children}
        </div>
    );
};

export {Impressao};